import { Outlet } from "react-router-dom";
import { AgentList } from "./AgentList/AgentList";
import AgentForm from "./AgentForm/AgentForm";
import AgentPrompts from "./AgentPrompts";
import AgentDialogs from "./AgentTestStage/AgentTestStage";
import { AgentIntegrations } from "./AgentIntegrations";
import { KnowledgeDocuments } from "./KnowledgeDocuments";
import AgentFunctions from "./AIFunctions/AgentFunctions";
import AgentFunctionForm from "./AIFunctions/AgentFunctionForm";
import { AgentStats } from "./AgentStats/AgentStats";
import Flow from "../Automations/AutomationConstructor/AutomationConstructor";
import { Automations } from "./Automation/Automations";
import Comments from "./Comments/Comments";

export const adminAIAgentsRoutes = [
  {
    path: "ai-agents",
    element: Outlet,
    children: [
      {
        path: "",
        redirect: "list",
      },
      {
        path: "list",
        element: AgentList,
      },
      {
        path: "add",
        element: AgentForm,
      },
      {
        path: ":id/settings",
        element: AgentForm,
      },
      {
        path: ":id/prompts",
        element: AgentPrompts,
      },
      {
        path: ":id/functions",
        element: AgentFunctions,
      },
      {
        path: ":id/functions/add",
        element: AgentFunctionForm,
      },
      {
        path: ":id/functions/edit/:functionID",
        element: AgentFunctionForm,
      },
      {
        path: ":id/dialogs",
        element: AgentDialogs,
      },
      {
        path: ":id/knowledge-documents",
        element: KnowledgeDocuments,
      },
      {
        path: ":id/integrations",
        element: AgentIntegrations,
      },
      {
        path: ":id/stats",
        element: AgentStats,
      },
      {
        path: ":id/comments",
        element: Comments,
      },
      {
        path: ":id/automations",
        element: Outlet,
        children: [
          {
            path: "list",
            element: Automations,
          },
          {
            path: "flow/:automationID",
            element: Flow,
          },
        ],
      },
    ],
  },
];
